import { render, staticRenderFns } from "./PaymentIcons.vue?vue&type=template&id=7777fecf&scoped=true"
import script from "./PaymentIcons.vue?vue&type=script&lang=js"
export * from "./PaymentIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7777fecf",
  null
  
)

export default component.exports